import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      border: `1px solid ${theme.palette.grey[100]}`,
    },
    '& .megadraft': {
      cursor: 'text',

      '& .megadraft-block .paragraph + .paragraph': {
        marginTop: theme.spacing(3),
      },

      [theme.breakpoints.down('md')]: {
        maxHeight: 100,
        overflow: 'scroll',
      },
    },
  },
  link: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'none',
  },
  customToolbarWrapper: {
    height: 0,
    marginTop: theme.spacing(-3.25),
    position: 'fixed',
    zIndex: 1,
  },
}));
